import styled from "styled-components";

const StyledLabel = styled.label`
  display: block;
  font-size: 1rem;
  border-bottom: 0.188rem solid #725798;
  width: 50%;
  margin: 0 auto;
  text-align: center;

  ${({ required }) =>
    required &&
    `
    &::after {
      content: "*";
      color: #B50444;
      margin-left: 0.125rem;
    }
  `}
`;

export default StyledLabel;
